export const inputCls = "w-full bg-[#0B0E17] border border-[#2A364F] rounded-md px-3 py-2 text-sm font-mono outline-none focus:border-[#F59E0B] transition-colors";

export const Field = ({ label, hint, children }) => (
  <div className="space-y-1.5">
    <label className="text-[11px] font-semibold uppercase tracking-wider text-[#64748B]">{label}</label>
    {children}
    {hint && <div className="text-[11px] text-[#94A3B8]">{hint}</div>}
  </div>
);

export const Panel = ({ title, children, right, testid }) => (
  <section data-testid={testid} className="bg-[#121724] border border-[#1E2738] rounded-lg p-4 sm:p-5 space-y-3">
    {(title || right) && <div className="flex items-center justify-between gap-2 flex-wrap"><h3 className="font-head text-base font-bold">{title}</h3>{right}</div>}
    {children}
  </section>
);

export const DEFAULT_SETTINGS = { ema_fast: 9, ema_slow: 21, rsi_period: 14, rsi_long_max: 65, rsi_short_min: 35, rsi_long_exit: 75, rsi_short_exit: 25, sl_pct: 3, tp_pct: 6, leverage: 3, margin_pct: 20, allow_shorts: true, start_balance: 1000 };

export const riskHints = (s) => {
  const lev = Number(s.leverage) || 1;
  return {
    slMargin: (Number(s.sl_pct) * lev).toFixed(1),
    tpMargin: (Number(s.tp_pct) * lev).toFixed(1),
    liqDist: (100 / lev).toFixed(1),
  };
};

export const fmtDate = (ms) => new Date(ms).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" });
export const fmtShort = (ms) => new Date(ms).toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit" });
export const pct = (v, d = 2) => `${Number(v) >= 0 ? "+" : ""}${Number(v || 0).toFixed(d)}%`;
export const usd = (v, d = 2) => Number(v || 0).toLocaleString("tr-TR", { minimumFractionDigits: d, maximumFractionDigits: d });
export const tone = (v) => (Number(v) > 0 ? "text-[#10B981]" : Number(v) < 0 ? "text-[#EF4444]" : "text-[#94A3B8]");
